export default Object.freeze({
    REDIRECT_PROFILE_PATH_QUERY: 'redirectProfilePath=',
});
